/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetRegistryPrivileges200ResponseData } from './GetRegistryPrivileges200ResponseData'
import {
  GetRegistryPrivileges200ResponseDataFromJSON,
  GetRegistryPrivileges200ResponseDataFromJSONTyped,
  GetRegistryPrivileges200ResponseDataToJSON,
} from './GetRegistryPrivileges200ResponseData'

/**
 *
 * @export
 * @interface GetRegistryPrivileges200Response
 */
export interface GetRegistryPrivileges200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetRegistryPrivileges200Response
   */
  status: boolean
  /**
   *
   * @type {GetRegistryPrivileges200ResponseData}
   * @memberof GetRegistryPrivileges200Response
   */
  data: GetRegistryPrivileges200ResponseData
}

/**
 * Check if a given object implements the GetRegistryPrivileges200Response interface.
 */
export function instanceOfGetRegistryPrivileges200Response(
  value: object
): value is GetRegistryPrivileges200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetRegistryPrivileges200ResponseFromJSON(
  json: any
): GetRegistryPrivileges200Response {
  return GetRegistryPrivileges200ResponseFromJSONTyped(json, false)
}

export function GetRegistryPrivileges200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetRegistryPrivileges200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetRegistryPrivileges200ResponseDataFromJSON(json['data']),
  }
}

export function GetRegistryPrivileges200ResponseToJSON(
  value?: GetRegistryPrivileges200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetRegistryPrivileges200ResponseDataToJSON(value['data']),
  }
}
